import { connect } from "react-redux";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
	CAlert,
	CButton,
	CCol,
	CForm,
	CFormSelect,
	CInputGroup,
	CInputGroupText,
	CNav,
	CNavItem, CNavLink,
	CRow, CTabContent, CTabPane
} from "@coreui/react";

import StoreListWhere from "../../../where/StoreListWhere";

import { DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import locale from "antd/es/date-picker/locale/ko_KR";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";

import * as formatter from "../../../../../config/formatter";
import * as o2Api from "../../../../../api/api";
import "src/scss/grid-styles.scss";
import StoreDetail from "../../../store/StoreDetail";
import StoreCorner from "../../../store/StoreCorner";
import HourlyDailySaleReport from "./hourlyDailySaleReport";
import HourlyRangeSaleReport from "./hourlyRangeSaleReport";
import HourlyMonthlySaleReport from "./hourlyMonthlySaleReport";

const HourlySaleReport = (props) => {
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);

	const [pos, setPos] = useState([{ deviceId: "전체" }]);
	const [currentSaleStatData, setCurrentSaleStatData] = useState([]);
	const [currentSaleData, setCurrentSaleData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({
		visible: false,
		message: ""
	});
	const [activeKey, setActiveKey] = useState(1);
	const [searchForm, setSearchForm] = useState({
		deviceId: "전체",
		saleDt: dayjs()
	});

	useEffect(() => {
		if (props.selected.storeCd.length > 0) {
			// getStoreDevice();
		}
	}, [props.selected.storeCd]);

	const search = () => {
		setError({
			visible: false,
			message: ""
		});

		const { cmpCd, brandCd, storeCd } = props.selected;
		if (brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (storeCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 매장은 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			posCd: searchForm.deviceId === "전체" ? "" : searchForm.deviceId,
			saleDt: searchForm.saleDt.format("YYYYMMDD")
		};

		setLoading(true);
		o2Api.getCurrentDayStats(params).then((result) => {
			const { responseBody, responseCode, responseMessage } = result.data;
			if (responseCode === "200") {
				console.log("stat : ", responseBody);

				setLoading(false);
				setCurrentSaleStatData(responseBody);

				getCurrentDay();
			}
		});
	};

	const getCurrentDay = () => {
		const { cmpCd, brandCd, storeCd } = props.selected;
		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			posCd: searchForm.deviceId === "전체" ? "" : searchForm.deviceId,
			saleDt: searchForm.saleDt.format("YYYYMMDD")
		};

		setLoading(true);
		o2Api.getCurrentDay(params).then((result) => {
			const { responseBody, responseCode, responseMessage } = result.data;
			if (responseCode === "200") {
				console.log("result : ", responseBody);

				setLoading(false);
				setCurrentSaleData(responseBody);
			}
		});
	};

	const onCellClicked = (e) => {
		switch (e.colDef.field) {
			case "billNo":
				// onDetail(e.data);
				break;
			case "tradeTypeNm":
				console.log(e.value);
				break;
			case "cashAmt":
				if (e.value > 0) {
					console.log(e.value);
				}
				break;
			case "cardAmt":
				if (e.value > 0) {
					console.log(e.value);
				}
				break;
		}
	};

	const onDetail = (data) => {
		console.log("data : ", data)
		const params = "value=123123";
		window.open('/#/sale/detail?' + params, "_detail", "width=800, height=600");
	}

	return (
		<>
			<div style={containerStyle}>
				{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
				<div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
					<h5>시간대별 매출현황</h5>
				</div>
				<CCol>
					<CNav variant="tabs" role="tablist">
						<CNavItem>
							<CNavLink
								active={activeKey === 1}
								onClick={() => setActiveKey(1)}>일기간</CNavLink>
						</CNavItem>
						<CNavItem>
							<CNavLink
								active={activeKey === 2}
								onClick={() => setActiveKey(2)}>일자별</CNavLink>
						</CNavItem>
						<CNavItem>
							<CNavLink
								active={activeKey === 3}
								onClick={() => setActiveKey(3)}>월별</CNavLink>
						</CNavItem>
					</CNav>
					<CTabContent>
						<CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
							<div style={{height: 10}}/>
							<HourlyRangeSaleReport />
						</CTabPane>
						<CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 2}>
							<div style={{height: 10}}/>
							<HourlyDailySaleReport />
						</CTabPane>
						<CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 3}>
							<div style={{height: 10}}/>
							<HourlyMonthlySaleReport />
						</CTabPane>
					</CTabContent>
				</CCol>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const { account, store, selected } = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(HourlySaleReport);
